import { motion } from "framer-motion"
import { useGlobalContext } from "../../data/GlobalContext"
import { promoURL } from "../../../App"
import { useMemo, useCallback, useEffect, useState, useRef } from "react"
import confetti from "canvas-confetti"

export default function LuckyDraw8({ onClose }) {
  const [luckyDrawEntries, setLuckyDrawEntries] = useState()
  const { username } = useGlobalContext()
  const canvasRef = useRef(null)
  const isLoggedIn = Boolean(username)

  useEffect(() => {
    if (isLoggedIn) {
      fetch(promoURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: `cmd=get8PromoCount&u=${username}`,
      })
        .then((response) => response.json())
        .then((data) => {
          if (typeof data?.entries === "number") {
            setLuckyDrawEntries(data.entries)
          } else {
            console.error("No Entry data found.")
          }
        })

        .catch((error) => {
          console.error("Error fetching commission data:", error)
        })
    }
  }, [isLoggedIn, username])

  // 🎉 Setup confetti instance once canvas is ready
  const myConfetti = useRef(null)
  useEffect(() => {
    if (!canvasRef.current) return
    myConfetti.current = confetti.create(canvasRef.current, {
      resize: true,
      useWorker: false,
    })
  }, [])

  // 🎯 Helper function to "fire" confetti
  const count = 200
  const defaults = useMemo(
    () => ({
      origin: { y: 0.7 },
      zIndex: 99999,
    }),
    []
  )

  const fire = useCallback(
    (particleRatio, opts) => {
      if (!myConfetti.current) return
      myConfetti.current({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      })
    },
    [defaults, count]
  )

  // 🚀 Run the confetti bursts on mount
  useEffect(() => {
    if (typeof window === "undefined") return
    fire(0.25, { spread: 26, startVelocity: 55 })
    fire(0.2, { spread: 60 })
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 })
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 })
    fire(0.1, { spread: 120, startVelocity: 45 })
  }, [fire])

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 999999,
        }}
      />
      <div className="daily-lucky-draw-entry">
        <div className="daily-lucky-draw-title">
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.7, ease: "easeInOut" }}
            src="/images/icon/8s-LUCKY_DRAW.webp"
            alt=""
          />
        </div>
        <div className="daily-lucky-draw-entries">
          <motion.p
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.7, ease: "easeInOut" }}
            className="entry"
          >
            <span>{luckyDrawEntries}</span>
          </motion.p>
        </div>
        <div className="daily-lucky-draw-jar">
          <div className="daily-lucky-draw-coins">
            <motion.img
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: [1, 1.1, 1] }}
              transition={{ duration: 1.7, ease: "easeInOut" }}
              src="/images/icon/LUCKY-8-LEAF.webp"
              alt=""
            />
          </div>
          <div className="daily-lucky-draw-coins-right">
            <motion.img
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: [1, 1.1, 1] }}
              transition={{ duration: 1.7, ease: "easeInOut" }}
              src="/images/icon/LUCKY-8-LEAF.webp"
              alt=""
            />
          </div>
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.7, ease: "easeInOut" }}
            className="jar"
            src="/images/icon/LUCKY-DRAW-ENTRY-JAR-TEXT.webp"
            alt=""
          />
        </div>
        <div className="daily-lucky-draw-entry-content">
          <motion.button
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.7, ease: "easeInOut" }}
            onClick={onClose}
          >
            Close
          </motion.button>
        </div>
      </div>
    </>
  )
}
